import React from "react";
import Header from "./Header";

type PageHeaderProps = {
  title: string;
  // 名刺のホーム画面に戻るボタンを出すか
  showBack?: boolean;
};

// 各画面の先頭に置く見出し帯。画面の一番外側（.top-page-container の直下）に置くこと
const PageHeader: React.FC<PageHeaderProps> = ({ title, showBack = false }) => (
  <section className="pageHeader">
    {showBack && <div className="pageHeader__back"><Header /></div>}
    <h1 className="pageHeader__title">{title}</h1>
  </section>
);

export default PageHeader;
